export function cleanJobTitle(title: string): string {
  if (!title) return '';
  let cleaned = title;
  cleaned = cleaned.replace(/\s*[\(\[-]?\s*feed\s*(?:number|num|no|#)?\s*\d+\s*[\)\]-]?/gi, '');
  cleaned = cleaned.replace(/\s*[\(\[-]?\s*feed\s*#?\s*\d+\s*[\)\]-]?/gi, '');
  cleaned = cleaned.replace(/\s*feed\s*#?\s*\d+/gi, '');
  cleaned = cleaned.replace(/\s*\(\s*feed\s*#?\s*\d+\s*\)/gi, '');
  cleaned = cleaned.replace(/\s*\[\s*feed\s*#?\s*\d+\s*\]/gi, '');
  cleaned = cleaned.replace(/\s*-\s*feed\s*#?\s*\d+/gi, '');
  cleaned = cleaned.replace(/\s*[\(\[-]?\s*ref\s*:\s*[^\)\]]+\s*[\)\]-]?/gi, '');
  cleaned = cleaned.replace(/\s*[\(\[-]?\s*ref\s*:\s*.*?\s*[\)\]-]?/gi, '');
  cleaned = cleaned.replace(/\s*-\s*$/, '');
  cleaned = cleaned.replace(/\s+/, ' ');
  return cleaned.trim();
}

export function formatEmployerSlug(slug: string): string {
  if (!slug || slug === 'verified') return 'Verified Employer';
  let clean = slug.toLowerCase()
    .replace(/-amp-/g, ' & ')
    .replace(/-and-/g, ' & ')
    .replace(/-s-/g, "'s ")
    .replace(/-s$/g, "'s")
    .replace(/-com$/g, '')
    .replace(/-inc$/g, ', Inc.')
    .replace(/-llc$/g, ' LLC')
    .replace(/-ltd$/g, ' Ltd.')
    .replace(/-gmbh$/g, ' GmbH')
    .replace(/-bv$/g, ' B.V.')
    .replace(/-srl$/g, ' S.r.l.')
    .replace(/-co$/g, ' Co.')
    .replace(/-corp$/g, ' Corp.')
    .replace(/--+/g, '-')
    .replace(/^-+|-+$/g, '');

  const words = clean.split(/[-\s]+/);
  const formatted = words.map((w, idx) => {
    const lw = w.toLowerCase();
    if (lw === 'ai') return 'AI';
    if (lw === 'hr') return 'HR';
    if (lw === 'us' || lw === 'u-s') return 'U.S.';
    if (lw === 'uk') return 'UK';
    if (lw === 'eu') return 'EU';
    if (lw === 'it') return 'IT';
    if (lw === 'ted') return 'TED';
    if (lw === 'yc') return 'YC';
    if (lw === '3ss') return '3SS';
    if (lw === 'saas' || lw === 'wesaas') return 'SaaS';
    if (lw === 'amp' || lw === '&') return '&';
    if (idx > 0 && (lw === 'of' || lw === 'the' || lw === 'in' || lw === 'for' || lw === 'at')) return lw;
    return w.charAt(0).toUpperCase() + w.slice(1);
  }).join(' ');

  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
}
